import { useTranslation } from "react-i18next";
import { LanguageShortname } from "../../../constants/language";
import LanguageButton from "../../atoms/LanguageButton";
//Styles
import "./styles.scss";
import DiagonalDivider from "../../atoms/DiagonalDivider";

const LanguageToggler = () => {
  const { i18n } = useTranslation();

  return (
    <div className="language-toggler">
      <LanguageButton
        active={i18n.language.includes(LanguageShortname.DE)}
        title={LanguageShortname.DE.toUpperCase()}
        handleClick={() => i18n.changeLanguage(LanguageShortname.DE)}
      />
      <DiagonalDivider />
      <LanguageButton
        active={i18n.language.includes(LanguageShortname.EN)}
        title={LanguageShortname.EN.toUpperCase()}
        handleClick={() => i18n.changeLanguage(LanguageShortname.EN)}
      />
      <DiagonalDivider />
      <LanguageButton
        active={i18n.language.includes(LanguageShortname.ES)}
        title={LanguageShortname.ES.toUpperCase()}
        handleClick={() => i18n.changeLanguage(LanguageShortname.ES)}
      />
    </div>
  );
};

export default LanguageToggler;
